import { render, staticRenderFns } from "./TransactionHistories.vue?vue&type=template&id=204eddc0&"
import script from "./TransactionHistories.vue?vue&type=script&lang=js&"
export * from "./TransactionHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports